import React, { useState } from "react";
import { Heart, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export const ParentFeedback = ({ date, home, onSaved }) => {
  const [review, setReview] = useState(home.review || "");
  const [busy, setBusy] = useState(false);
  const send = async (body) => {
    setBusy(true);
    try { await api.post("/student/diary/feedback", { date, ...body }); onSaved(); toast.success("Thank you for your feedback"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not send feedback"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/60 p-4 space-y-2" data-testid="parent-feedback">
      <p className="text-sm font-bold text-rose-900">Parents: how was today's teaching?</p>
      <p className="text-xs text-rose-800/80">Only the PTG office sees your like and review.</p>
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={() => send({ like: !home.like })} disabled={busy} data-testid="feedback-like"
          className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-bold transition-colors ${home.like ? "bg-rose-600 text-white" : "bg-white text-rose-700 ring-1 ring-rose-300 hover:bg-rose-100"}`}>
          <Heart className={`h-4 w-4 ${home.like ? "fill-white" : ""}`} /> {home.like ? "Liked" : "Like"}
        </button>
      </div>
      <textarea value={review} onChange={(e) => setReview(e.target.value)} rows={2} maxLength={1000} placeholder="Write a short review (optional)"
        className="w-full rounded-lg border border-rose-200 bg-white p-2 text-sm" data-testid="feedback-review" />
      <Button size="sm" onClick={() => send({ review })} disabled={busy || review === (home.review || "")} className="bg-rose-600 hover:bg-rose-700" data-testid="feedback-review-save">
        {busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Send review
      </Button>
    </div>
  );
};
